import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/membership/user-memberships/${resource.id}/edit`} />,
    <MenuItem primaryText='User' key='user' value={`/security/users/${resource.member_id}/edit`} />,
    <MenuItem primaryText='Plan' key='plan' value={`/membership/membership-plans/${resource.membership_plan_id}/edit`} />
  ]
}

export default buildMenuItems
